export default "__VITE_ASSET__kHLn14tH__"